module.exports = __webpack_public_path__ + "img/rehab-white.337e9b0a.svg";